<span
  [class]="
    'pr-input-control ' + (variant === 'ASSET_SUPPORT' ? 'search-assets' : '')
  "
>
  @if (variant === 'ASSET_SUPPORT') {
    <pr-icon
      width="24"
      viewboxWidth="24"
      name="sp-search"
      (click)="searchValue = undefined"
      [class.pointer]="searchValue"
    ></pr-icon>
  }
  <input [(ngModel)]="searchValue" [placeholder]="placeholder" />
  <ng-content select="[filterSelection]"></ng-content>
  @if (variant === 'DEFAULT') {
    <pr-icon
      [name]="searchValue ? 'close' : 'search'"
      (click)="searchValue = undefined"
      [class.pointer]="searchValue"
    ></pr-icon>
  }
</span>
